import React, { useContext } from 'react';

import Row from 'components/Common/Row';
import useFormatPaymentAmount from 'components/DriverAX/components/AdditionalPayments/useFormatPaymentAmount';
import { BonusOverviewContext } from 'components/DriverAX/providers/BonusOverviewProvider';
import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';

// The section's heading, laid out like a bonus reward's (RewardHeading): icon,
// title, and the amount on the right — here the period's recognition payment
// total. A star rather than the reward pass/fail tick, as having no payments
// isn't a failure.
const RecognitionPaymentsHeading = ({ title }: { title: string }) => {
  const { bonusOverview } = useContext(BonusOverviewContext);
  const formatAmount = useFormatPaymentAmount();
  const rewardOutput = bonusOverview?.actualRewardOutput;
  const total = rewardOutput?.totalAdditionalPayments ?? 0;
  const hasPayments = (rewardOutput?.additionalPayments ?? []).length > 0;
  const isDisqualified = rewardOutput?.eligibleForBonus === 'disqualified';

  return (
    <Row spaceBetween centerAlign style={{ height: 48 }}>
      <Row centerAlign style={{ gap: 8 }}>
        <Icon
          icon={'start - filled'}
          color={
            hasPayments
              ? 'var(--color-status-success)'
              : 'var(--color-text-muted)'
          }
          height={20}
          width={20}
        />
        <Typography.Header type={'H3'}>{title}</Typography.Header>
      </Row>
      {rewardOutput && (
        <div style={{ textAlign: 'right' }}>
          <Typography.Header
            type={'H3'}
            color={
              hasPayments && !isDisqualified
                ? undefined
                : 'var(--color-text-muted)'
            }
          >
            {formatAmount(isDisqualified ? 0 : total)}
          </Typography.Header>
          {hasPayments && isDisqualified && (
            <Typography.Body type={'Body 12'} color={'var(--color-text-muted)'}>
              {'(disqualified)'}
            </Typography.Body>
          )}
        </div>
      )}
    </Row>
  );
};

export default RecognitionPaymentsHeading;
